import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-secondary-50 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg">
                <i className="ri-book-open-line text-lg"></i>
              </div>
              <span className="text-lg font-bold font-heading text-foreground-950">韩漫网址</span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              海量韩国漫画免费在线阅读平台，提供无删减下拉式韩漫阅读体验。覆盖恋爱、奇幻、动作、悬疑、喜剧、剧情等多种题材。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 font-heading">热门分类</h4>
            <ul className="space-y-2">
              {categories.filter(c => c.slug !== 'all').slice(0, 4).map(cat => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200"
                  >
                    {cat.name}韩漫
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 font-heading">快速链接</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200">首页</Link>
              </li>
              <li>
                <Link to="/category/all" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200">全部漫画</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200">关于我们</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 font-heading">联系我们</h4>
            <ul className="space-y-2 text-sm text-foreground-600">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-primary-500 mt-0.5"></i>
                <span>contact@hanman.example.com</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-customer-service-2-line text-primary-500 mt-0.5"></i>
                <span>在线客服：工作日 9:00-18:00</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 韩漫网址 - 韩国漫画无删减漫画下拉式阅读平台。本站所有内容仅供学习交流。
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <span>韩国漫画</span>
            <span>·</span>
            <span>无删减漫画</span>
            <span>·</span>
            <span>免费韩漫</span>
          </div>
        </div>
      </div>
    </footer>
  );
}